export default "__VITE_ASSET__c7008e5a__"